export default "__VITE_ASSET__DZHM8AC$__"